/* eslint-disable react/prop-types */

import classNames from "classnames";

//import classes from "./image.module.scss";

function Image({ src, alt, onLoad, isLoaded, placeholder, className }) {
  return (
    <img
      src={isLoaded ? src : placeholder}
      alt={alt}
      className={classNames(className)}
      onLoad={onLoad}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = placeholder;
      }}
    />
  );
}

export default Image;
